import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { styled } from '@stitches/react';

// 组件属性类型定义
interface AnimatedSectionProps {
  children: ReactNode;
  delay?: number; // 动画延迟时间（秒）
  direction?: 'up' | 'down' | 'left' | 'right'; // 动画方向
  className?: string; // 自定义样式类
}

// 组件样式
const StyledSection = styled(motion.div, {
  width: '100%',
  overflow: 'hidden',
});

// 根据方向设置初始动画状态
const getInitialPosition = (direction: 'up' | 'down' | 'left' | 'right') => {
  switch (direction) {
    case 'up':
      return { y: 50, opacity: 0 };
    case 'down':
      return { y: -50, opacity: 0 };
    case 'left':
      return { x: 50, opacity: 0 };
    case 'right':
      return { x: -50, opacity: 0 };
    default:
      return { y: 50, opacity: 0 };
  }
};

// 区块动画组件
const AnimatedSection: React.FC<AnimatedSectionProps> = ({
  children,
  delay = 0,
  direction = 'up',
  className,
}) => {
  // 初始动画状态
  const initialPosition = getInitialPosition(direction);
  
  // 动画变体
  const variants = {
    hidden: initialPosition,
    visible: {
      x: 0,
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        delay: delay,
        ease: [0.22, 1, 0.36, 1], // 自定义缓动函数
      },
    },
  };

  return (
    <StyledSection
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-100px' }}
      variants={variants}
    >
      {children}
    </StyledSection>
  );
};

export default AnimatedSection; 